import jsPDF from "jspdf";
import DateConverter from "@heartinz/date_and_time_processor";
import uRLs from "../../baseUtils";
import QRCode from "qrcode";
import autoTable from "jspdf-autotable";
import { useAuth } from "../../../context/AuthProvider";
import { usePermission } from "../../../context/PermissionContext";
import { FormatedSaleData } from "../GlobelSaleData";
import React, { useState } from "react";
import { capitalizeFirstLetter } from "../a4Invoices/common/invoiceUtils";
import { useEffect } from "react";
 const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
const loadImageDimensions = (base64Src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = reject;
    img.src = base64Src;
  });
};
  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

// invoice
export const generateIN_HA4_4PDF = async (data, storeSettings, selectedTheme,optData) => { 
  const doc = new jsPDF("p", "mm", "a4");
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const HALF_PAGE_HEIGHT = 140;
  const PADDING = 5;
  const MARGIN_LEFT = PADDING;
  const MARGIN_RIGHT = pageW - PADDING;
  const centerX = pageW / 2;
  let y = PADDING; // Starting height
   const isBillReceipt =
      data?.salemode?.toUpperCase() === "BILL" &&
      storeSettings?.saleSettings?.saleModeSettings?.isBill_isTax;
      const documentTitle = isBillReceipt
        ? "BILL RECEIPT"
        : "TAX INVOICE";
      const invLabel1 = isBillReceipt ? "Bill No. " : "Invoice No. ";
  if (data?.salefrom?.image) {
    try {
      const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;
      const logoBase64 = await urlToBase64(imagePath);
      const { width, height } = await loadImageDimensions(logoBase64);
      
      // 1. DRAW LOGO (Far Left)
      const maxWidth = 30;
      const maxHeight = 12;
      const ratio = Math.min(maxWidth / width, maxHeight / height);
      const finalW = width * ratio;
      const finalH = height * ratio;
  
      const headerTopY = y;
  
      // ==================== LOGO ====================
      const logoX = MARGIN_LEFT;
      const logoY = headerTopY;
      
      doc.addImage(
        logoBase64,
        "PNG",
        logoX,
        logoY,
        finalW,
        finalH
      );
      
      // ==================== LEFT SIDE ====================
      const leftStartX = logoX + finalW + 4;
      
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(7.5);
      doc.setTextColor(0);
      
      doc.text(
        data?.salefrom?.title?.toUpperCase() || "",
        leftStartX,
        headerTopY + 3
      );
      
      let leftY = headerTopY + 6;
      
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(6.8);
      doc.setTextColor(0);
      
      const addrLine1 = [
        data?.salefrom?.addressline1,
        data?.salefrom?.addressline2,
        data?.salefrom?.district,
        data?.salefrom?.state,
        data?.salefrom?.pincode,
      ]
        .filter(Boolean)
        .join(", ");  
      
      if (addrLine1) {
        doc.text(addrLine1, leftStartX, leftY);
        leftY += 3;
      }  
      const phone = data?.salefrom?.phone;
      const gstin = data?.salefrom?.gstnumber;
      
      if (phone) {
        doc.setFont("Inter-Bold", "bold");
        doc.text("Ph:", leftStartX, leftY);
      
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          phone,
          leftStartX + doc.getTextWidth("Ph: ") + 1,
          leftY
        );
      
        leftY += 3;
      }
      
      if (gstin) {
        doc.setFont("Inter-Bold", "bold");
        doc.text("GSTIN:", leftStartX, leftY);
      
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          gstin,
          leftStartX + doc.getTextWidth("GSTIN: ") + 1,
          leftY
        );
      
        leftY += 3;
      }
      
      // ==================== RIGHT SIDE ====================
      const invLabel = invLabel1; 
      const invVal = data?.saleno || "-";
      const timezone = data?.saleby?.timezone; 
      const invDateTime = DateConverter.ISOToDisplayFormat(
        DateConverter.convertToTimeZone(data?.saledate, timezone)
      ).time;
      
      const dateStr = `DATE: ${
        data?.saledate
          ? DateConverter.ISOToDisplayFormat(data?.saledate).date
          : "-"
      }`;
      const timeStr = `TIME: ${invDateTime || "-"}`; 
      const combinedDateTimeStr = `${dateStr}   ${timeStr}`;
      let rightY = headerTopY + 3;
      
      // 1. TAX INVOICE Heading
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.setTextColor(0); 
      doc.text(
        documentTitle,
        MARGIN_RIGHT,
        rightY,
        { align: "right" }
      );
      
      rightY += 4;
      
      // 2. Invoice No. Block (Bold Value)
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7.5);
     doc.setTextColor(0); 
      
      const invValW = doc.getTextWidth(invVal);
      doc.text(
        invLabel,
        MARGIN_RIGHT - invValW,
        rightY,
        { align: "right" }
      );
      
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(0); 
      doc.text(
        invVal,
        MARGIN_RIGHT,
        rightY,
        { align: "right" }
      );
      
      rightY += 2;
  
      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0);
      doc.setFontSize(7);
      const totalDateTimeWidth = doc.getTextWidth(combinedDateTimeStr);
      const lineStartX = MARGIN_RIGHT - totalDateTimeWidth;
      
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || 200); 
      doc.setLineWidth(0.1);
      doc.line(lineStartX, rightY, MARGIN_RIGHT, rightY); 
      
      rightY += 3; 
      
      // 4. Render Date and Time on a SINGLE line
       doc.setTextColor(0);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        combinedDateTimeStr,
        MARGIN_RIGHT,
        rightY,
        { align: "right" }
      );
      
      // ==================== HEADER BOTTOM ====================
      const headerBottom = Math.max(
        leftY,
        rightY,
        headerTopY + finalH
      );
      
      y = headerBottom;
      
    } catch (e) {
      console.warn("Header layout failed", e);
      y += 15;
    }
  }
  
  y += 1;
  
  if (data?.saleto && optData?.isCustomerDisplay) {
    let rowHeight = 5; 
    doc.setDrawColor(
      selectedTheme?.templateTheme?.borderColor || [200, 200, 200]
    );
    doc.setLineWidth(0.2);
  
    doc.setFont("Inter-Regular", "normal"); 
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text("To : ", MARGIN_LEFT + 2, y + 3.5);
  
    const labelWidth = doc.getTextWidth("To : ");
    const nameXPosition = MARGIN_LEFT + 2 + labelWidth;
  
    doc.setFont("Inter-Bold", "bold");
    doc.text(data?.saleto?.name || "", nameXPosition, y + 3.5);
    doc.setFont("Inter-Regular", "normal");
    rowHeight += 3;
    
    const fullAddress = [[
      data?.saleto?.addressline1,
      data?.saleto?.addressline2,
      data?.saleto?.district,
      data?.saleto?.state,
      data?.saleto?.pincode ? `- ${data.saleto.pincode}` : "",
    ] ,[
      data.saleto?.gstnumber ? `GSTIN: ${data.saleto.gstnumber}` : "",
      data.saleto?.phone ? `Mobile: ${data.saleto.phone}` : "",
      data.saleto?.referenceid ? `Reference No: ${data.saleto.referenceid}` : "",
       data.saleto?.fssai ? `FASSI: ${data.saleto.fssai}` : "",
      data.saleto?.cinnumber ? `CIN: ${data.saleto.cinnumber}` : "",
      data.saleto?.pannumber ? `PAN: ${data.saleto.pannumber}` : "",
    ]
      .filter(Boolean)
      .join(" | "),
      
  ]
      .filter(Boolean)
      .join("\n");
   
    if (fullAddress ) {
      const wrappedAddr = doc.splitTextToSize(
        fullAddress ,
        pageW / 2 + 10
      );
      doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 8);
      rowHeight += wrappedAddr.length * 3;
    }
   
    doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
    y += rowHeight;
  }

  /* -------------------------------------------------
     PRODUCT TABLE
  ------------------------------------------------- */
  const rowCount = data?.saleitems?.length;
  const standardHeight = 4;
  const targetTotalHeight = 40;
  const extraSpace =
    rowCount > 0 && rowCount <= 5
      ? targetTotalHeight - rowCount * standardHeight
      : 0;

  autoTable(doc, {
    startY: y,
    theme: "plain",
    rowPageBreak: "avoid",
    margin: {
      top: PADDING,
      left: PADDING,
      right: PADDING,
      bottom: pageH - HALF_PAGE_HEIGHT + PADDING,
    },
    styles: {
      font: "Inter-Regular",
      fontSize: 6.5,
      cellPadding: 1.5,
      valign: "top",
      lineWidth: 0, 
    },
    headStyles: {
      font: "Inter-Bold",
      fontSize: 7,
      fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], 
      textColor: selectedTheme?.templateTheme?.foregroundColor,
      lineWidth: 0.2,
      lineColor: selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
    },
    bodyStyles: {
      minCellHeight: Math.max(2, standardHeight),
    },
    head: [[" SI", "Description of Good", "HSN/SAC", "MRP","Disc","RATE","QTY",  "Tax Amt","GST %","CGST", "SGST","Total"]],
    body: data?.saleitems.map((it, i) => [
      i + 1,
      it.title,
      it.hsnsac,
      `₹${it?.mrp}`,
      `₹${it?.lineTotalDiscount}`,
      `₹${it.soldprice}`,     
       `${it.quantity} ${(() => {
        const unitCode = it?.isSecondaryUnit
          ? it?.unitConfig?.secondaryUnitCode
          : it?.unitConfig?.primaryUnitCode;
        return unitCode || "";
      })()}`,
   
      `₹${it.lineTotalTaxAmount}`,
      `₹${it?.taxpercentage}%`,
      `₹${it?.lineTotalCgstAmount}`,
      `₹${it.lineTotalSgstAmount}`,
      `₹${it.lineTotalSoldPrice}`,
    ]),
    columnStyles: {
      0: { cellWidth: 10, halign: "center" },
      1: { cellWidth: "auto", halign: "left" },
      2: { cellWidth: 15, halign: "right" },
      3: { cellWidth: 16, halign: "right" },
      4: { cellWidth: 16, halign: "right" },
      5: { cellWidth: 16, halign: "right" },
      6: { cellWidth: 16, halign: "center" },
      7: { cellWidth: 16, halign: "right" },
      8: { cellWidth: 11, halign: "center" },
      9: { cellWidth: 16, halign: "right" },
      10: { cellWidth: 16, halign: "right" },
       11: { cellWidth: 16, halign: "right" },
    },
    didParseCell: function (data) {
      if (data.section === "head") {
        const colId = data.column.index;
        if ([0, 6, 8].includes(colId)){ data.cell.styles.halign = "center";
         }
          if ([2, 3, 4, 5, 7, 9,10,11].includes(colId)) {
          data.cell.styles.halign = "right";
          }
      }
      if (data.section === "body") {
        data.cell.styles.lineWidth = {
          left: 0.1,
          right: 0.1,
          top: 0,
          bottom: 0,
        };
        data.cell.styles.lineColor = selectedTheme?.templateTheme?.borderColor || [200, 200, 200]; 
        if (data.row.index === rowCount - 1) {
          data.cell.styles.minCellHeight = standardHeight + extraSpace;
        }
        if (data.row.index === rowCount - 1) {
          data.cell.styles.lineWidth.bottom = 0.1;
        }
      }
    },
    didDrawPage: function (data) {
      const finalY = data.cursor.y;
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
      doc.line(PADDING, finalY, pageW - PADDING, finalY); 
    },
  });

  const tableEndY = doc.lastAutoTable.finalY;
  const borderColor = selectedTheme?.templateTheme?.borderColor || [200, 200, 200];
  
  doc.setDrawColor(borderColor);
  doc.setLineWidth(0.1);
  
  // =====================================================
  // SUMMARY ROW
  // =====================================================
  const summaryRowY = tableEndY;
  const summaryRowH = 5;
  
  doc.rect(
    PADDING,
    summaryRowY,
    pageW - PADDING * 2,
    summaryRowH
  );
  
  const colWidths = [10, 36, 15, 16, 16, 16, 16, 16, 11, 16, 16,16];
  let x = PADDING;
  
  colWidths.forEach((w) => {
    x += w;
    doc.line(x, summaryRowY, x, summaryRowY + summaryRowH);
  });
  
  const summaryCenterY = summaryRowY + 3.5;
   doc.setTextColor(0);
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(6.3);
  doc.text("Total :", PADDING + 36, summaryCenterY);
  doc.text(`₹${data?.totalmrp|| 0}`, PADDING + 75, summaryCenterY, { align: "right" });
   doc.text(`${data?.totaldiscount || 0}`, PADDING + 92, summaryCenterY, { align: "right" });
  doc.text(`₹${data?.totalsaleprice || 0}`, PADDING + 108, summaryCenterY, { align: "right" });
 
  doc.text(`₹${data?.totaltaxamount || 0}`, PADDING + 135, summaryCenterY, { align: "right" });
  doc.text(`₹${data?.cgstamount || 0}`, PADDING + 167, summaryCenterY, { align: "right" });
  doc.text(`₹${data?.sgstamount || 0}`, PADDING + 183, summaryCenterY, { align: "right" });
  doc.text(`₹${data?.grandtotal || 0}`, pageW - PADDING - 2, summaryCenterY, { align: "right" });
  
  // =====================================================
  // RUPEES IN WORDS ROW
  // =====================================================
  const rowH = 5;
  const wordsRowY = summaryRowY + summaryRowH;
  const rightSectionWidth = 48;
  const totalLabelX = MARGIN_RIGHT - rightSectionWidth;
   doc.setTextColor(0);
  doc.rect(PADDING, wordsRowY, pageW - PADDING * 2, rowH);
  doc.line(totalLabelX, wordsRowY, totalLabelX, wordsRowY + rowH);
  
  const textY = wordsRowY + rowH / 2 + 1;
  
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(6.5);
  doc.text("Rupees in words:", PADDING + 2, textY);
  
  doc.setFont("Inter-Regular", "normal");
  const words = data?.amountinwords || "Zero Rupees Only";
  doc.text(words, PADDING + 23, textY, { maxWidth: totalLabelX - PADDING - 17 });
  
  doc.setFont("Inter-Bold", "bold");
  doc.text(`TOTAL   AMOUNT : ₹${data?.grandtotal}`, MARGIN_RIGHT - 2, textY, { align: "right" });
  
  // =====================================================
  // TERMS & CONDITIONS SECTION (With Dynamic Page Break)
  // =====================================================
  // let currentSectionY = wordsRowY + rowH + 7;
  //=====================================================
// REMARK SECTION (Below Amount in Words)
//=====================================================

let currentSectionY = wordsRowY + rowH + 4;

if (optData?.isRemark && data?.remark?.trim()) {

  const remarkTitle = "Remark";
  const remarkWidth = pageW - (PADDING * 2);

  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);

  const remarkLines = doc.splitTextToSize(
    capitalizeFirstLetter(data.remark),
    remarkWidth - 6
  );

  const lineHeight = 3.5;  
  const paddingTop = 2;
  const paddingBottom = 2;

  const remarkHeight =
  (remarkLines.length * lineHeight) + paddingTop + paddingBottom;
  // Move to next page if remark doesn't fit
  if (
    currentSectionY + remarkHeight + 25 >
    HALF_PAGE_HEIGHT - 5
  ) {
    doc.addPage();
    currentSectionY = PADDING + 5;
  }

  // Heading
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(8);
  doc.text(remarkTitle, PADDING, currentSectionY);

  currentSectionY += 2;

  // Border
  doc.setDrawColor(
    selectedTheme?.templateTheme?.borderColor || 180
  );
  doc.setLineWidth(0.2);


  // Text
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);

  let remarkY = currentSectionY + 3;

  remarkLines.forEach(line => {
    doc.text(line, PADDING , remarkY);
    remarkY += lineHeight;
  });

  currentSectionY += remarkHeight + 2;
}

// ==============================
// Bank + QR + Signature Section
// ==============================

let sectionY = currentSectionY ;

const leftX = PADDING;
const qrSize = 28;
const qrX = (pageW - qrSize) / 2;
const rightX = MARGIN_RIGHT;

// ---------- Calculate Heights ----------
let bankHeight = 0;

if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
  bankHeight = 5; // title

  if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName)
    bankHeight += 4;

  if (storeSettings?.paymentSettings?.bankDetails?.accountNo)
    bankHeight += 4;

  if (storeSettings?.paymentSettings?.bankDetails?.ifsc)
    bankHeight += 4;

  if (storeSettings?.paymentSettings?.upiId)
    bankHeight += 4;
}  const upiId = storeSettings?.paymentSettings?.upiId;
  const beneficiaryName =
    storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "";

const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
        beneficiaryName
      )}&cu=INR`;

      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl);

let qrHeight =
  qrCodeDataUrl && optData?.isBankDetails ? qrSize : 0;

let signHeight = storeSettings?.invoiceSettings?.signature ? 22 : 14;

// Take tallest block
const blockHeight = Math.max(bankHeight, qrHeight, signHeight);

// Page break if required
if (sectionY + blockHeight > pageH - PADDING) {
  doc.addPage();
  sectionY = PADDING;
}
    let bankY = sectionY+2;

    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0); 
  doc.text("Bank Details", leftX, bankY);
  bankY += 5;
  const bankDetails = [];
  if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
    bankDetails.push({ label: "Name", value: storeSettings.paymentSettings.bankDetails.beneficiaryName });
  }

  if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
    bankDetails.push({ label: "Account #", value: storeSettings.paymentSettings.bankDetails.accountNo });
  }

  if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
    bankDetails.push({ label: "IFSC", value: storeSettings.paymentSettings.bankDetails.ifsc });
  }

  if (storeSettings?.paymentSettings?.upiId) {
    bankDetails.push({ label: "UPI", value: storeSettings.paymentSettings.upiId });
  }

  
  const labelWidthOffset = 18; 

  bankDetails.forEach((item) => {
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0, 0, 0); 
    doc.text(`${item.label} :`, leftX, bankY);
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0, 0, 0); 
    doc.text(String(item.value || ""), leftX + labelWidthOffset, bankY);

    bankY += 4.5; 
  });

  doc.setTextColor(0, 0, 0);
}

    if (qrCodeDataUrl && optData?.isBankDetails) {
      doc.addImage(
        qrCodeDataUrl,
        "PNG",
        qrX,
        sectionY-3,
        qrSize,
        qrSize
      );
    }

      let signBottom = sectionY;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
     sectionY+=2
      doc.text(
        `For ${data?.salefrom?.title}`,
        rightX,
        sectionY,
        { align: "right" }
      );

      if (storeSettings?.invoiceSettings?.signature) {
        try {
          const signimg =
            uRLs.IMAGE_URL +
            storeSettings.invoiceSettings.signature;

          const base64 = await urlToBase64(signimg);

          const { width, height } =
            await loadImageDimensions(base64);

          const maxWidth = 25;
          const maxHeight = 10;

          const ratio = Math.min(
            maxWidth / width,
            maxHeight / height
          );

          const imgW = width * ratio;
          const imgH = height * ratio;

          doc.addImage(
            base64,
            signimg.endsWith(".png") ? "PNG" : "JPEG",
            rightX - imgW,
            sectionY + 4,
            imgW,
            imgH
          );

                signBottom = sectionY + 4 + imgH;
        } catch {}
      } else {
        doc.line(
          rightX - 30,
          sectionY + 10,
          rightX,
          sectionY + 10
        );

        signBottom = sectionY + 5;
      }

      doc.setFont("Inter-Regular", "normal");
      doc.text(
        "Authorized Signatory",
        rightX,
        signBottom + 5,
        { align: "right" }
      );

      signBottom += 5;

      let sectionEndY = Math.max(
        bankY,
        sectionY + qrHeight,
        signBottom
      );

  const TERMS_WIDTH = (pageW - PADDING * 2);
  
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);
  const termLines = doc.splitTextToSize(data?.terms || "", TERMS_WIDTH);
  const termsHeight = 4 + (termLines.length * 3);
  const sigSectionHeight = 18; 
  const totalSectionHeight = Math.max(sigSectionHeight, termsHeight);
 
  if (sectionEndY + totalSectionHeight > HALF_PAGE_HEIGHT - 5) {
    doc.addPage();
    sectionEndY = PADDING ; 
  }
sectionEndY+=2
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.text("Terms & Conditions", PADDING, sectionEndY);
  
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);
   doc.setTextColor(0);
  let termsTextY = sectionEndY + 4;
  termLines.forEach((line) => {
    doc.text(line, PADDING, termsTextY);
    termsTextY += 3;
  });    
  
  // =====================================================
  y = currentSectionY + totalSectionHeight + 4;
       
  if (storeSettings?.negobillBranding) {
    const minGapY = y + 3;
    const bottomLimitY = HALF_PAGE_HEIGHT - 5;
    let finalBrandingY = Math.max(minGapY, bottomLimitY);
    
    // Safety check if branding calculations push out of the active breakdown sheet
    if (finalBrandingY > doc.internal.pageSize.getHeight() - 10) {
      finalBrandingY = doc.internal.pageSize.getHeight() - 10;
    }
    
    const normalText = "Powered by ";
    const boldText = "NegoBill.com";
    
    doc.setFontSize(8);   
    doc.setFont("Inter-Regular", "normal");
    const normalW = doc.getTextWidth(normalText);  
    doc.setFont("Inter-Bold", "bold");
    const boldW = doc.getTextWidth(boldText);  
    const totalWidth = normalW + boldW;
    const startX = MARGIN_RIGHT - totalWidth; 
    
    doc.setFont("Inter-Regular", "normal");
    doc.text(normalText, startX, finalBrandingY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(boldText, startX + normalW, finalBrandingY);
  }
  
  return doc;
};
  
  export const generateBILL_HA4_4PDF = async (data, storeSettings, selectedTheme,optData) => { 
  const doc = new jsPDF("p", "mm", "a4");
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const HALF_PAGE_HEIGHT = 140;
  const PADDING = 5;
  const MARGIN_LEFT = PADDING;
  const MARGIN_RIGHT = pageW - PADDING;
  const centerX = pageW / 2;
  let y = PADDING; // Starting height
  
  if (data?.salefrom?.image) {
    try {
      const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;
      const logoBase64 = await urlToBase64(imagePath);
      const { width, height } = await loadImageDimensions(logoBase64);
      
      // 1. DRAW LOGO (Far Left)
      const maxWidth = 30;
      const maxHeight = 12;
      const ratio = Math.min(maxWidth / width, maxHeight / height);
      const finalW = width * ratio;
      const finalH = height * ratio;
  
      const headerTopY = y;
  
      // ==================== LOGO ====================
      const logoX = MARGIN_LEFT;
      const logoY = headerTopY;
      
      doc.addImage(
        logoBase64,
        "PNG",
        logoX,
        logoY,
        finalW,
        finalH
      );
      
      // ==================== LEFT SIDE ====================
      const leftStartX = logoX + finalW + 4;
      
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(7.5);
      doc.setTextColor(0);
      
      doc.text(
        data?.salefrom?.title?.toUpperCase() || "",
        leftStartX,
        headerTopY + 3
      );
      
      let leftY = headerTopY + 6;
      
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.setTextColor(0);
      
      const addrLine1 = [
        data?.salefrom?.addressline1,
        data?.salefrom?.addressline2,
        data?.salefrom?.district,
        data?.salefrom?.state,
        data?.salefrom?.pincode,
      ]
        .filter(Boolean)
        .join(", ");  
      
      if (addrLine1) {
        doc.text(addrLine1, leftStartX, leftY);
        leftY += 3.2;
      }  
      const phone = data.salefrom?.phone;
      
      if (phone) {
        doc.setFont("Inter-Bold", "bold");
        doc.text("Ph:", leftStartX, leftY);
      
        doc.setFont("Inter-Regular", "normal");
        doc.text(
          phone,
          leftStartX + doc.getTextWidth("Ph: ") + 1,
          leftY
        );
      
        leftY += 3;
      }
          
      // ==================== RIGHT SIDE ====================
      const invLabel = "Bill No. "; 
      const invVal = data?.saleno || "-";
      const timezone = data?.saleby?.timezone; 
      const invDateTime = DateConverter.ISOToDisplayFormat(
        DateConverter.convertToTimeZone(data?.saledate, timezone)
      ).time;
      
      const dateStr = `DATE: ${
        data.saledate
          ? DateConverter.ISOToDisplayFormat(data?.saledate).date
          : "-"
      }`;
      const timeStr = `TIME: ${invDateTime || "-"}`; 
      const combinedDateTimeStr = `${dateStr}   ${timeStr}`;
      let rightY = headerTopY + 3;
      
      // 1. TAX INVOICE Heading
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.setTextColor(0); 
      doc.text(
        "BILL RECEIPT",
        MARGIN_RIGHT,
        rightY,
        { align: "right" }
      );
      
      rightY += 4;
      
      // 2. Invoice No. Block (Bold Value)
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7.5);
     doc.setTextColor(0); 
      
      const invValW = doc.getTextWidth(invVal);
      doc.text(
        invLabel,
        MARGIN_RIGHT - invValW,
        rightY,
        { align: "right" }
      );
      
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(0); 
      doc.text(
        invVal,
        MARGIN_RIGHT,
        rightY,
        { align: "right" }
      );
      
      rightY += 2;
  
      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0);
      doc.setFontSize(7);
      const totalDateTimeWidth = doc.getTextWidth(combinedDateTimeStr);
      const lineStartX = MARGIN_RIGHT - totalDateTimeWidth;
      
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || 200); 
      doc.setLineWidth(0.1);
      doc.line(lineStartX, rightY, MARGIN_RIGHT, rightY); 
      
      rightY += 3; 
      
      // 4. Render Date and Time on a SINGLE line
       doc.setTextColor(0);
      doc.setFont("Inter-Regular", "normal");
      doc.text(
        combinedDateTimeStr,
        MARGIN_RIGHT,
        rightY,
        { align: "right" }
      );
      
      // ==================== HEADER BOTTOM ====================
      const headerBottom = Math.max(
        leftY,
        rightY,
        headerTopY + finalH
      );
      
      y = headerBottom;
      
    } catch (e) {
      console.warn("Header layout failed", e);
      y += 15;
    }
  }
  
  y += 2;
  
  if (data?.saleto && optData?.isCustomerDisplay) {
    let rowHeight = 5; 
    doc.setDrawColor(
      selectedTheme?.templateTheme?.borderColor || [200, 200, 200]
    );
    doc.setLineWidth(0.2);
  
    doc.setFont("Inter-Regular", "normal"); 
    doc.setFontSize(8);
    doc.setTextColor(0);
    doc.text("To : ", MARGIN_LEFT + 2, y + 3.5);
  
    const labelWidth = doc.getTextWidth("To : ");
    const nameXPosition = MARGIN_LEFT + 2 + labelWidth;
  
    doc.setFont("Inter-Bold", "bold");
    doc.text(data?.saleto?.name || "", nameXPosition, y + 3.5);
    doc.setFont("Inter-Regular", "normal");
    rowHeight += 3;
    
    const fullAddress = [[
      data?.saleto?.addressline1,
      data?.saleto?.addressline2,
      data?.saleto?.district,
      data?.saleto?.state,
       data?.saleto?.pincode ? `- ${data.saleto.pincode}` : "",
    ],[
      data.saleto?.gstnumber ? `GSTIN: ${data.saleto.gstnumber}` : "",
      data.saleto?.phone ? `Mobile: ${data.saleto.phone}` : "",
      data.saleto?.referenceid ? `Reference No: ${data.saleto.referenceid}` : "",
       data.saleto?.fssai ? `FASSI: ${data.saleto.fssai}` : "",
      data.saleto?.cinnumber ? `CIN: ${data.saleto.cinnumber}` : "",
      data.saleto?.pannumber ? `PAN: ${data.saleto.pannumber}` : "",
    ]  
     .filter(Boolean)
      .join(" | "),
      
  ]
      .filter(Boolean)
      .join("\n ");
   
    if (fullAddress ) {
      const wrappedAddr = doc.splitTextToSize(
        fullAddress ,
        pageW / 2 + 10
      );
      doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 8);
      rowHeight += wrappedAddr.length * 3;
    }
   
    doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
    y += rowHeight;
  }

  /* -------------------------------------------------
     PRODUCT TABLE
  ------------------------------------------------- */
  const rowCount = data?.saleitems?.length;
  const standardHeight = 4;
  const targetTotalHeight = 40;
  const extraSpace =
    rowCount > 0 && rowCount <= 5
      ? targetTotalHeight - rowCount * standardHeight
      : 0;

  autoTable(doc, {
    startY: y,
    theme: "plain",
    rowPageBreak: "avoid",
    margin: {
      top: PADDING,
      left: PADDING,
      right: PADDING,
      bottom: pageH - HALF_PAGE_HEIGHT + PADDING,
    },
    styles: {
      font: "Inter-Regular",
      fontSize: 6.5,
      cellPadding: 1.5,
      valign: "top",
      lineWidth: 0, 
    },
    headStyles: {
      font: "Inter-Bold",
      fontSize: 7,
      fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], 
      textColor: selectedTheme?.templateTheme?.foregroundColor,
      lineWidth: 0.2,
      lineColor: selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
    },
    bodyStyles: {
      minCellHeight: Math.max(2, standardHeight),
    },
    head: [[" SI", "Description of Good", "HSN/SAC","MRP","Disc", "RATE", "QTY", "Total"]],
    body: data?.saleitems.map((it, i) => [
      i + 1,
      it.title,
      it.hsnsac,
      `₹${it.mrp}`, 
      `₹${it?.lineTotalDiscount}`,
      `₹${it.soldprice}`, 
      `${it.quantity} ${(() => {
        const unitCode = it?.isSecondaryUnit
          ? it?.unitConfig?.secondaryUnitCode
          : it?.unitConfig?.primaryUnitCode;
        return unitCode || "";
      })()}`,   
            
      `₹${it.lineTotalSoldPrice}`,
    ]),
    columnStyles: {
      0: { cellWidth: 10, halign: "center" },
      1: { cellWidth: "auto", halign: "left" },
      2: { cellWidth: 15, halign: "right" },
      3: { cellWidth: 16, halign: "right" },
      4: { cellWidth: 16, halign: "right" },
      5: { cellWidth: 16, halign: "right" },
      6: { cellWidth: 16, halign: "center" },
      7: { cellWidth: 16, halign: "right" },
    
    },
    didParseCell: function (data) {
      if (data.section === "head") {
        const colId = data.column.index;
        if (colId === 0 || colId === 6) data.cell.styles.halign = "center";
        if (colId === 2 || colId === 4 || colId === 5 || colId === 3 || colId === 7 )
          data.cell.styles.halign = "right";
      }
      if (data.section === "body") {
        data.cell.styles.lineWidth = {
          left: 0.1,
          right: 0.1,
          top: 0,
          bottom: 0,
        };
        data.cell.styles.lineColor = selectedTheme?.templateTheme?.borderColor || [200, 200, 200]; 
        if (data.row.index === rowCount - 1) {
          data.cell.styles.minCellHeight = standardHeight + extraSpace;
        }
        if (data.row.index === rowCount - 1) {
          data.cell.styles.lineWidth.bottom = 0.1;
        }
      }
    },
    didDrawPage: function (data) {
      const finalY = data.cursor.y;
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
      doc.line(PADDING, finalY, pageW - PADDING, finalY); 
    },
  });

  const tableEndY = doc.lastAutoTable.finalY;
  const borderColor = selectedTheme?.templateTheme?.borderColor || [200, 200, 200];
  
  doc.setDrawColor(borderColor);
  doc.setLineWidth(0.1);
  
  // =====================================================
  // SUMMARY ROW
  // =====================================================
  const summaryRowY = tableEndY;
  const summaryRowH = 5;
  
  doc.rect(
    PADDING,
    summaryRowY,
    pageW - PADDING * 2,
    summaryRowH
  );
  
  const colWidths = [10, 95, 15, 16, 16, 16, 16, 16];
  let x = PADDING;
  
  colWidths.forEach((w) => {
    x += w;
    doc.line(x, summaryRowY, x, summaryRowY + summaryRowH);
  });
  
  const summaryCenterY = summaryRowY + 3.5;
   doc.setTextColor(0);
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(6.3);
  doc.text("Total :", PADDING + 97, summaryCenterY);
   doc.text(`₹${data?.totalmrp|| 0}`, PADDING + 134, summaryCenterY, { align: "right" });
 doc.text(`${data?.totaldiscount || 0}`, PADDING + 151, summaryCenterY, { align: "right" });
  doc.text(`₹${data?.totalsaleprice || 0}`, PADDING + 167, summaryCenterY, { align: "right" });
  
  doc.text(`₹${data?.grandtotal || 0}`, pageW - PADDING - 2, summaryCenterY, { align: "right" });
  
  // =====================================================
  // RUPEES IN WORDS ROW
  // =====================================================
  const rowH = 5;
  const wordsRowY = summaryRowY + summaryRowH;
  const rightSectionWidth = 48;
  const totalLabelX = MARGIN_RIGHT - rightSectionWidth;
   doc.setTextColor(0);
  doc.rect(PADDING, wordsRowY, pageW - PADDING * 2, rowH);
  doc.line(totalLabelX, wordsRowY, totalLabelX, wordsRowY + rowH);
  
  const textY = wordsRowY + rowH / 2 + 1;
  
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(6.5);
  doc.text("Rupees in words:", PADDING + 2, textY);
  
  doc.setFont("Inter-Regular", "normal");
  const words = data?.amountinwords || "Zero Rupees Only";
  doc.text(words, PADDING + 23, textY, { maxWidth: totalLabelX - PADDING - 17 });
  
  doc.setFont("Inter-Bold", "bold");
  doc.text(`TOTAL   AMOUNT : ₹${data?.grandtotal}`, MARGIN_RIGHT - 2, textY, { align: "right" });
  
  // =====================================================
  // TERMS & CONDITIONS SECTION (With Dynamic Page Break)
  // =====================================================
let currentSectionY = wordsRowY + rowH + 4;

if (optData?.isRemark && data?.remark?.trim()) {

  const remarkTitle = "Remark";
  const remarkWidth = pageW - (PADDING * 2);

  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);

  const remarkLines = doc.splitTextToSize(
    capitalizeFirstLetter(data.remark),
    remarkWidth - 6
  );

  const lineHeight = 3.5;  
  const paddingTop = 2;
  const paddingBottom = 2;

  const remarkHeight =
  (remarkLines.length * lineHeight) + paddingTop + paddingBottom;
  // Move to next page if remark doesn't fit
  if (
    currentSectionY + remarkHeight + 25 >
    HALF_PAGE_HEIGHT - 5
  ) {
    doc.addPage();
    currentSectionY = PADDING + 5;
  }

  // Heading
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(8);
  doc.text(remarkTitle, PADDING, currentSectionY);

  currentSectionY += 2;

  // Border
  doc.setDrawColor(
    selectedTheme?.templateTheme?.borderColor || 180
  );
  doc.setLineWidth(0.2);



  // Text
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);

  let remarkY = currentSectionY + 3;

  remarkLines.forEach(line => {
    doc.text(line, PADDING, remarkY);
    remarkY += lineHeight;
  });

  currentSectionY += remarkHeight + 2;
}

// ==============================
// Bank + QR + Signature Section
// ==============================

let sectionY = currentSectionY ;

const leftX = PADDING;
const qrSize = 28;
const qrX = (pageW - qrSize) / 2;
const rightX = MARGIN_RIGHT;

// ---------- Calculate Heights ----------
let bankHeight = 0;

if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
  bankHeight = 5; // title

  if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName)
    bankHeight += 4;

  if (storeSettings?.paymentSettings?.bankDetails?.accountNo)
    bankHeight += 4;

  if (storeSettings?.paymentSettings?.bankDetails?.ifsc)
    bankHeight += 4;

  if (storeSettings?.paymentSettings?.upiId)
    bankHeight += 4;
}  const upiId = storeSettings?.paymentSettings?.upiId;
  const beneficiaryName =
    storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "";

const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
        beneficiaryName
      )}&cu=INR`;

      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl);

let qrHeight =
  qrCodeDataUrl && optData?.isBankDetails ? qrSize : 0;

let signHeight = storeSettings?.invoiceSettings?.signature ? 22 : 14;

// Take tallest block
const blockHeight = Math.max(bankHeight, qrHeight, signHeight);

// Page break if required
if (sectionY + blockHeight > pageH - PADDING) {
  doc.addPage();
  sectionY = PADDING;
}
    let bankY = sectionY+2;

    if (optData?.isBankDetails && storeSettings?.paymentSettings?.bankDetails) {
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0); 
  doc.text("Bank Details", leftX, bankY);
  bankY += 5;
  const bankDetails = [];
  if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
    bankDetails.push({ label: "Name", value: storeSettings.paymentSettings.bankDetails.beneficiaryName });
  }

  if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
    bankDetails.push({ label: "Account #", value: storeSettings.paymentSettings.bankDetails.accountNo });
  }

  if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
    bankDetails.push({ label: "IFSC", value: storeSettings.paymentSettings.bankDetails.ifsc });
  }

  if (storeSettings?.paymentSettings?.upiId) {
    bankDetails.push({ label: "UPI", value: storeSettings.paymentSettings.upiId });
  }

  
  const labelWidthOffset = 18; 

  bankDetails.forEach((item) => {
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0, 0, 0); 
    doc.text(`${item.label} :`, leftX, bankY);
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0, 0, 0); 
    doc.text(String(item.value || ""), leftX + labelWidthOffset, bankY);

    bankY += 4.5; 
  });

  doc.setTextColor(0, 0, 0);
}

    if (qrCodeDataUrl && optData?.isBankDetails) {
      doc.addImage(
        qrCodeDataUrl,
        "PNG",
        qrX,
        sectionY-3,
        qrSize,
        qrSize
      );
    }

      let signBottom = sectionY;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
     sectionY+=2
      doc.text(
        `For ${data?.salefrom?.title}`,
        rightX,
        sectionY,
        { align: "right" }
      );

      if (storeSettings?.invoiceSettings?.signature) {
        try {
          const signimg =
            uRLs.IMAGE_URL +
            storeSettings.invoiceSettings.signature;

          const base64 = await urlToBase64(signimg);

          const { width, height } =
            await loadImageDimensions(base64);

          const maxWidth = 25;
          const maxHeight = 10;

          const ratio = Math.min(
            maxWidth / width,
            maxHeight / height
          );

          const imgW = width * ratio;
          const imgH = height * ratio;

          doc.addImage(
            base64,
            signimg.endsWith(".png") ? "PNG" : "JPEG",
            rightX - imgW,
            sectionY + 4,
            imgW,
            imgH
          );

                signBottom = sectionY + 4 + imgH;
        } catch {}
      } else {
        doc.line(
          rightX - 30,
          sectionY + 10,
          rightX,
          sectionY + 10
        );

        signBottom = sectionY + 5;
      }

      doc.setFont("Inter-Regular", "normal");
      doc.text(
        "Authorized Signatory",
        rightX,
        signBottom + 5,
        { align: "right" }
      );

      signBottom += 5;

      let sectionEndY = Math.max(
        bankY,
        sectionY + qrHeight,
        signBottom
      );

  const TERMS_WIDTH = (pageW - PADDING * 2);
  
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);
  const termLines = doc.splitTextToSize(data?.terms || "", TERMS_WIDTH);
  const termsHeight = 4 + (termLines.length * 3);
  const sigSectionHeight = 18; 
  const totalSectionHeight = Math.max(sigSectionHeight, termsHeight);
 
  if (sectionEndY + totalSectionHeight > HALF_PAGE_HEIGHT - 5) {
    doc.addPage();
    sectionEndY = PADDING ; 
  }
  sectionEndY+=2  
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(8);
  doc.setTextColor(0);
  doc.text("Terms & Conditions", PADDING, sectionEndY);
  
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);
   doc.setTextColor(0);
  let termsTextY = sectionEndY + 4;
  termLines.forEach((line) => {
    doc.text(line, PADDING, termsTextY);
    termsTextY += 3;
  });    
  
  
  
  // =====================================================
  // BRANDING FOOTER SECTION
  // =====================================================
  y = currentSectionY + totalSectionHeight + 4;
       
  if (storeSettings?.negobillBranding) {
    const minGapY = y + 3;
    const bottomLimitY = HALF_PAGE_HEIGHT - 5;
    let finalBrandingY = Math.max(minGapY, bottomLimitY);
    
    // Safety check if branding calculations push out of the active breakdown sheet
    if (finalBrandingY > doc.internal.pageSize.getHeight() - 10) {
      finalBrandingY = doc.internal.pageSize.getHeight() - 10;
    }
    
    const normalText = "Powered by ";
    const boldText = "NegoBill.com";
    
    doc.setFontSize(8);   
    doc.setFont("Inter-Regular", "normal");
    const normalW = doc.getTextWidth(normalText);  
    doc.setFont("Inter-Bold", "bold");
    const boldW = doc.getTextWidth(boldText);  
    const totalWidth = normalW + boldW;
    const startX = MARGIN_RIGHT - totalWidth; 
    
    doc.setFont("Inter-Regular", "normal");
    doc.text(normalText, startX, finalBrandingY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(boldText, startX + normalW, finalBrandingY);
  }
  
  return doc;
};
const ClassicInvoice = ({data,  selectedTheme,selectedSize,optData}) => { 
     const {storeSettings, } =usePermission();
     const {settings} = useAuth();
     const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
     const globalData = FormatedSaleData(data);
     const saleDate = globalData?.saledate;
     const timezone = globalData?.saleby?.timezone;   
     let saleTime = "--:--";
     if (saleDate) {
       const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
       saleTime = DateConverter.ISOToDisplayFormat(zoned);
     }
      const isBillReceipt =
      globalData?.salemode?.toUpperCase() === "BILL" &&
      storeSettings?.saleSettings?.saleModeSettings?.isBill_isTax;
      const documentTitle = isBillReceipt
        ? "BILL RECEIPT"
        : "TAX INVOICE";
      const invLabel = isBillReceipt ? "Bill No:" : "Invoice No:";
      useEffect(() => {
          const upi = storeSettings?.paymentSettings?.upiId;
      
          const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
          if (!upi) return; // skip until upi is available
      
          const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
          console.log("ip", upiUrl);
          QRCode.toDataURL(upiUrl)
            .then((url) => {
              setQrCodeDataUrl(url);
            })
            .catch((err) => {
              console.error("QR Code generation failed: ", err);
            });
        }, [
          storeSettings?.paymentSettings?.upiId,
          storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
        ]);
  return  <>
      <>
         {globalData?.salemode === "INVOICE" || isBillReceipt? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in" style={{ padding: "20px" }}>
                   <div className="tm_invoice_in p-2">
                                   <table width="100%" className="pdfcontent">
                                     <tbody>
                                       <tr>
                                         <td width="60%" style={{ textAlign: "left" }}>
                                           <div className="d-flex gap-3 align-items-start">
                                             <div className="tm_logo">
                                               {("/assets/images/logo-light.png" ||
                                                 settings?.saleProfileData?.image) && (
                                                 <img
                                                   src={
                                                     settings?.saleProfileData?.image
                                                       ? uRLs.IMAGE_URL +
                                                         "profile/" +
                                                         settings?.saleProfileData?.image
                                                       : "/assets/images/logo-light.png"
                                                   }
                                                   className="img-rounded logo mb-0"
                                                   height="30"
                                                 />
                                               )}
                                             </div>
                                             <div
                                               style={{ fontSize: "13px", lineHeight: "16px" }}
                                             >
                                               <div style={{ fontWeight: "600" }} >
                                                 {settings?.saleProfileData?.title || ""}{" "}
                                               
                                               </div>
                 <div className="font-12">
                        {settings?.saleProfileData?.addressline1}{" "} {settings?.saleProfileData?.addressline2}{" "}
                        {settings?.saleProfileData?.pincode || ""}
                      </div>
                     
                      <div className="font-12">
                        <span className="fw-bold">Ph:</span>{" "}
                        {settings?.saleProfileData?.phone}{" "}
                       
                      </div>       
                      <div>
                         <span className="fw-bold">GSTIN:</span>{" "}
                        {settings?.saleProfileData?.gstnumber}</div>                                      
                                                            
                                             </div>
                                           </div>
                                         </td>
                                         <td width="40%" style={{ textAlign: "right" }}>
                                           <div className="tm_primary_color tm_f50 tm_text_uppercase font-14 fw-bold">
                                             {globalData?.salemode &&
                                               formatTrackMode(globalData?.salemode)}
                                           </div>
                                           {globalData?.status === "CANCELLED" && (
                                             <span className="badge rounded-pill bg-label-danger mt-3 font-14 tm_text_uppercase">
                                               {globalData?.status}
                                             </span>
                                           )}
                                            <div style={{ flex: "1", textAlign: "right" }}>
                                            <div className="mt-1"
                                              style={{ display: "inline-block", textAlign: "right" }}
                                            >
                                              <div
                                                className=" font-12"
                                                style={{
                                                  borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                Invoice No.
                                                <span className="fw-bold"> {globalData?.saleno}</span>
                                              </div>
                                              <div className="d-flex justify-content-end font-12">
                                              
                                                <span> DATE: {saleTime?.date}</span>
                                                <span className="ms-3">TIME:{saleTime?.time}</span>
                                              </div>
                                            </div>
                                          </div>
                                         </td>
                                       </tr>
                                     </tbody>
                                   </table>                                 
                                   </div>
                
                 {data?.saleto &&  optData?.isCustomerDisplay &&(
                  <div
                    className="d-flex mt-1"
                    style={{
                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                    }}
                  >
                    <div
                      style={{
                        flex: "1",
                        padding: "5px",
                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                      }}
                    >
                      <span className="fw-bold font-13">
                        To :                      <span className="font-14 ">{data?.saleto?.name}</span>
                      </span>

                      <div className="font-10">
                        {" "}
                        {globalData?.saleto?.addressline1 &&
                          `${globalData?.saleto?.addressline1}, `}
                        {globalData?.saleto?.addressline2 &&
                          `${globalData?.saleto?.addressline2}, `}
                        {globalData?.saleto?.district &&
                          `${globalData?.saleto?.district}, `}
                        {globalData?.saleto?.pincode &&
                          ` - ${globalData?.saleto?.pincode}`}
                      </div>
                       <div  className="font-10">
                                                                                                {[
                                                        globalData?.saleto?.gstnumber && `GSTIN: ${globalData.saleto.gstnumber}`,
                                                        globalData?.saleto?.phone && `Mobile: ${globalData.saleto.phone}`,
                                                        globalData?.saleto?.referenceid &&
                                                          `Reference No: ${globalData.saleto.referenceid}`,
                                                        globalData?.saleto?.fssai && `FSSAI: ${globalData.saleto.fssai}`,
                                                        globalData?.saleto?.cinnumber && `CIN: ${globalData.saleto.cinnumber}`,
                                                        globalData?.saleto?.pannumber && `PAN: ${globalData.saleto.pannumber}`,
                                                      ]
                                                        .filter(Boolean)
                                                        .map((item, index, arr) => (
                                                          <React.Fragment key={index}>
                                                            <span>{item}</span>
                                                            {index < arr.length - 1 && (
                                                              <span style={{ margin: "0 5px" }}>|</span>
                                                            )}
                                                          </React.Fragment>
                                                        ))}
                            
                                                          </div>
                    </div>
                    
                  </div>
                   )}
                  <table
                    width="100%"
                    className="mt-0"
                    style={{ borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr className=" fw-bold">
                        <th
                          className="force-style font-10 py-1"
                          style={{
                            width: "40px",

                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                        >
                          {" "}
                          SI
                        </th>
                        <th
                          className="force-style font-10 py-1"
                          style={{
                            textAlign: "left",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                        >
                          Description of Good
                        </th>
                          <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          HSN/SAC
                        </th>
                          <th
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                        >
                          MRP
                        </th>
                                                <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Disc
                        </th>


                        <th
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                        >
                          RATE
                        </th>
                         <th
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                        >
                          QTY
                        </th>
                        <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Tax Amt
                        </th>
                           <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "70px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          GST %
                        </th>
                          <th
                          // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          CGST
                        </th>
                           <th
                          // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          SGST
                        </th>
                        <th
                          // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {globalData?.saleitems?.map((item, index) => (
                        <tr
                          key={index}
                          className="font-10"
                          style={{ height: "30px",verticalAlign: "top" }}
                        >
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,

                              textAlign: "center",
                              borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              padding: "0 5px",
                            }}
                          >
                            {item?.title}
                          </td>
  <td 
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {item?.hsnsac}
                          </td>
                             <td
                              className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                             
                            }}
                          >
                            ₹{item?.mrp}
                          </td>
                          <td  
                           className="pe-1"                        
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalDiscount}
                          </td>
                          <td
                           className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                            
                            }}
                          >
                            ₹{item?.soldprice}
                          </td>
                          <td                           
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {item?.quantity} 
                            {(() => {
                              const unitCode = item?.isSecondaryUnit
                                ? item?.unitConfig?.secondaryUnitCode
                                : item?.unitConfig?.primaryUnitCode;
                              return unitCode || "";
                            })()}
                          </td>                          
                          
                          <td
                           className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalTaxAmount}
                          </td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            ₹{item?.taxpercentage}%
                          </td>
                            <td
                             className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalCgstAmount}
                          </td>
                            <td
                            className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalSgstAmount}
                          </td>
                          <td
                           className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                             
                            }}
                          >
                            ₹{item?.lineTotalSoldPrice}
                          </td>
                        </tr>
                      ))}

                      {[
                        ...Array(
                          Math.max(0, 5 - (globalData?.saleitems?.length || 0))
                        ),
                      ].map((_, i) => (
                        <tr key={`empty-${i}`} style={{ height: "50px" }}>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                    <tr 
                       className="font-11 fw-bold" 
      style={{ 
        borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
        borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
                      }}
                    >
                      <td style={{ textAlign: "right",  borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}></td>
                      <td className="font-11"
                        colSpan="1" 
                        style={{ 
                          textAlign: "right", 
                          padding: "6px",
                          borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
                        }}
                      >
                        Total :
                      </td>
                      <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                    
                      </td>
                        <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                          {globalData?.totalmrp || ""}
                      </td>
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                      {globalData?.totaldiscount || ""}
                      </td>
                    
                    <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                        ₹{globalData?.totalsaleprice}
                      </td>
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                          
                      </td>    
                    
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                        ₹{globalData?.totaltaxamount}
                      </td>
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                      
                      </td>
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                        ₹{globalData?.cgstamount}
                      </td>
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                        ₹{globalData?.sgstamount}
                      </td>
                      
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                        ₹{globalData?.grandtotal}
                      </td>
                       </tr>
                     
                      <tr className="font-11">
                        <td
                          colSpan="9"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "left",
                            padding: "6px",
                          }}
                        >
                          <span className="fw-bold">Rupees in words:</span>{" "}
                          {globalData?.amountinwords}
                        </td>
                        <td
                        className="font-11"
                          colSpan="3"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            padding: "6px",
                            fontWeight: "bold",
                          }}
                        >
                          TOTAL AMOUNT : <span className="ms-2 font-11"> ₹{globalData?.grandtotal}</span> 
                        </td>
                    
                      </tr>
                     

                    </tfoot>
                  
                  </table>
                   {optData?.isRemark && globalData?.remark ? (
                      <>
                      <div className="font-12 mt-2 fw-600 text-black mb-1">
                       Remark
                      </div>
                    
                      <div
                      className="font-12 mb-2 p-0"
                  style={{               
                whiteSpace: "pre-wrap",
               wordBreak: "break-word",
              }}
               >
              {capitalizeFirstLetter(globalData?.remark)}
               </div>
              </>
                ) : null}  
                 <div className="row mt-2 p-2">                                     
                     <div className="col-4 p-2 pt-0  border-dark font-11">
                       {storeSettings?.paymentSettings?.bankDetails && optData?.isBankDetails && (
                         <>
                          <strong>Bank Details:</strong>
                           <div className="d-flex font-11">
                               <span style={{ width: "80px" }} >
                                Name:
                                </span>
                                 { storeSettings?.paymentSettings?.bankDetails?.beneficiaryName}
                          </div>
                           <div className="d-flex font-11">
                             <span style={{ width: "80px" }}>
                              Account #:
                             </span>
                             {storeSettings?.paymentSettings?.bankDetails?.accountNo}
                            </div>
                           <div className="d-flex font-11">
                           <span  style={{ width: "80px" }} >
                             IFSC:
                           </span>
                           {storeSettings?.paymentSettings?.bankDetails?.ifsc}
                            </div>
                          <div className="d-flex font-11">
                          <span style={{ width: "80px" }} >
                           UPI ID:
                           </span>
                           {storeSettings?.paymentSettings?.upiId}
                           </div>{" "}
                        </>
                       )}
                        </div>
                   {qrCodeDataUrl &&  optData?.isBankDetails && (
                       <div className="col-3 d-flex align-items-center justify-content-end">
                         <img
                           src={qrCodeDataUrl}
                          alt="QR"
                         style={{width: "100px",height: "100px",}}
                         />
                      </div>
                    )}                                           
                                                          
                 <div className="col-5  ms-auto">
                    <div className="text-end p-0 fw-bold font-12 mt-2 ">
                    {globalData?.salefrom?.title}
                    </div>
                      <div>
                    {storeSettings?.invoiceSettings
                   ?.signature ? (
                       <div className="text-end p-0 fw-bold pb-1">
                   <img
                     src={
                      uRLs.IMAGE_URL +storeSettings?.invoiceSettings?.signature}
                      width={100}
                  />
                   </div>
                ) : (
                  <div className="p-0 pt-4">
               <hr
                className="m-1 ms-auto "
            style={{
                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                 maxWidth: "120px",
              }}
               />
             </div>
                   )}
                     <div className="text-end p-0 font-12">
                  Authorized Signatory
                    </div>
                       </div>
                      </div>                                                      
                  </div>                
                          <div className="d-flex mt-2 ">                     
                          <div
                                        className="font-10  fw-600"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        <strong>Terms & Conditions</strong>
                                    
                                      <div className="terms-box font-10">{storeSettings?.invoiceSettings?.termsAndConditions}</div>
                           </div>                          
                          </div>
                  {storeSettings?.negobillBranding && (
                    <>
                      <div className="mt-5 font-12 d-flex justify-content-end ">
                        <span>
                          Powered By{" "}
                          <span className="fw-bold">NegoBill.com</span>
                        </span>
                      </div>
                    </>
                  )} 
                </div>
              </div>
            </div>
          </div>
        ) : data?.salemode === "BILL" ? (
           <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in" style={{ padding: "20px" }}>
                   <div className="tm_invoice_in p-2">
                                   <table width="100%" className="pdfcontent">
                                     <tbody>
                                       <tr>
                                         <td width="60%" style={{ textAlign: "left" }}>
                                           <div className="d-flex gap-3 align-items-start">
                                             <div className="tm_logo">
                                               {("/assets/images/logo-light.png" ||
                                                 settings?.saleProfileData?.image) && (
                                                 <img
                                                   src={
                                                     settings?.saleProfileData?.image
                                                       ? uRLs.IMAGE_URL +
                                                         "profile/" +
                                                         settings?.saleProfileData?.image
                                                       : "/assets/images/logo-light.png"
                                                   }
                                                   className="img-rounded logo mb-0"
                                                   height="30"
                                                 />
                                               )}
                                             </div>
                                             <div
                                               style={{ fontSize: "13px", lineHeight: "16px" }}
                                             >
                                               <div style={{ fontWeight: "600" }} >
                                                 {settings?.saleProfileData?.title || ""}{" "}
                                               
                                               </div>
                                              <div className="font-12">
                                                      {settings?.saleProfileData?.addressline1}{" "} {settings?.saleProfileData?.addressline2}{" "}
                                                      {settings?.saleProfileData?.pincode || ""}
                                                    </div>
                                                  
                                                    <div className="font-12">
                                                      <span className="fw-bold">Ph:</span>{" "}
                                                      {settings?.saleProfileData?.phone}{" "}
                                                    
                                                    </div>                                                                 
                                                            
                                             </div>
                                           </div>
                                         </td>
                                         <td width="40%" style={{ textAlign: "right" }}>
                                           <div className="tm_primary_color tm_f50 tm_text_uppercase font-14 fw-bold">
                                             {globalData?.salemode &&
                                               formatTrackMode(globalData?.salemode)}
                                           </div>
                                           {globalData?.status === "CANCELLED" && (
                                             <span className="badge rounded-pill bg-label-danger mt-3 font-14 tm_text_uppercase">
                                               {globalData?.status}
                                             </span>
                                           )}
                                            <div style={{ flex: "1", textAlign: "right" }}>
                                            <div className="mt-1"
                                              style={{ display: "inline-block", textAlign: "right" }}
                                            >
                                              <div
                                                className=" font-12"
                                                style={{
                                                  borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                Invoice No.
                                                <span className="fw-bold"> {globalData?.saleno}</span>
                                              </div>
                                              <div className="d-flex justify-content-end font-12">
                                              
                                                <span> DATE: {saleTime?.date}</span>
                                                <span className="ms-3">TIME:{saleTime?.time}</span>
                                              </div>
                                            </div>
                                          </div>
                                         </td>
                                       </tr>
                                     </tbody>
                                   </table>                                 
                                   </div>
                
               {data?.saleto &&  optData?.isCustomerDisplay &&(
                  <div
                    className="d-flex mt-1"
                    style={{
                      border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                    }}
                  >
                    <div
                      style={{
                        flex: "1",
                        padding: "5px",
                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                      }}
                    >
                      <span className="fw-bold font-13">
                        To :                      <span className="font-14 ">{globalData?.saleto?.name}</span>
                      </span>

                      <div className="font-10">
                        {" "}
                        {globalData?.saleto?.addressline1 &&
                          `${globalData?.saleto?.addressline1}, `}
                        {globalData?.saleto?.addressline2 &&
                          `${globalData?.saleto?.addressline2}, `}
                        {globalData?.saleto?.district &&
                          `${globalData?.saleto?.district}, `}
                        {globalData?.saleto?.pincode &&
                          ` - ${globalData?.saleto?.pincode}`}
                      </div>
<div  className="font-10">
                                                                                                {[
                                                        globalData?.saleto?.gstnumber && `GSTIN: ${globalData.saleto.gstnumber}`,
                                                        globalData?.saleto?.phone && `Mobile: ${globalData.saleto.phone}`,
                                                        globalData?.saleto?.referenceid &&
                                                          `Reference No: ${globalData.saleto.referenceid}`,
                                                        globalData?.saleto?.fssai && `FSSAI: ${globalData.saleto.fssai}`,
                                                        globalData?.saleto?.cinnumber && `CIN: ${globalData.saleto.cinnumber}`,
                                                        globalData?.saleto?.pannumber && `PAN: ${globalData.saleto.pannumber}`,
                                                      ]
                                                        .filter(Boolean)
                                                        .map((item, index, arr) => (
                                                          <React.Fragment key={index}>
                                                            <span>{item}</span>
                                                            {index < arr.length - 1 && (
                                                              <span style={{ margin: "0 5px" }}>|</span>
                                                            )}
                                                          </React.Fragment>
                                                        ))}
                            
                                                          </div>                      
                    </div>
                    
                  </div>
               )}
                  <table
                    width="100%"
                    className="mt-0"
                    style={{ borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr className=" fw-bold">
                        <th
                          className="force-style font-10 py-1"
                          style={{
                            width: "40px",

                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                        >
                          {" "}
                          SI
                        </th>
                        <th
                          className="force-style font-10 py-1"
                          style={{
                            textAlign: "left",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                        >
                          Description of Good
                        </th>
                          <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          HSN/SAC
                        </th>
                          <th
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                        >
                          MRP
                        </th>
                                                <th
                          // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Disc
                        </th>


                        <th
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                        >
                          RATE
                        </th>
                         <th
                          className="force-style font-10 py-1"
                          style={{
                            width: "80px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                          //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                        >
                          QTY
                        </th>                      
                        <th
                          // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                          className="force-style font-10 py-1"
                          style={{
                            width: "100px",
                            textAlign: "right",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {globalData?.saleitems?.map((item, index) => (
                        <tr
                          key={index}
                          className="font-10"
                          style={{ height: "30px",verticalAlign: "top" }}
                        >
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,

                              textAlign: "center",
                              borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              padding: "0 5px",
                            }}
                          >
                            {item?.title}
                          </td>
  <td 
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {item?.hsnsac}
                          </td>
                             <td
                              className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                             
                            }}
                          >
                            ₹{item?.mrp}
                          </td>
                          <td  
                           className="pe-1"                        
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",
                            }}
                          >
                            ₹{item?.lineTotalDiscount}
                          </td>
                          <td
                           className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                            
                            }}
                          >
                            ₹{item?.soldprice}
                          </td>
                          <td                           
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "center",
                            }}
                          >
                            {item?.quantity} 
                            {(() => {
                              const unitCode = item?.isSecondaryUnit
                                ? item?.unitConfig?.secondaryUnitCode
                                : item?.unitConfig?.primaryUnitCode;
                              return unitCode || "";
                            })()}
                          </td>                         
                                                   
                          <td
                           className="pe-1"
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              textAlign: "right",                             
                            }}
                          >
                            ₹{item?.lineTotalSoldPrice}
                          </td>
                        </tr>
                      ))}

                      {[
                        ...Array(
                          Math.max(0, 5 - (globalData?.saleitems?.length || 0))
                        ),
                      ].map((_, i) => (
                        <tr key={`empty-${i}`} style={{ height: "50px" }}>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                              borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                         
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                          <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                            <td
                            style={{
                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            }}
                          ></td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                    <tr 
                       className="font-11 fw-bold" 
      style={{ 
        borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
        borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
                      }}
                    >
                      <td style={{ textAlign: "right",  borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}></td>
                      <td className="font-11"
                        colSpan="1" 
                        style={{ 
                          textAlign: "right", 
                          padding: "6px",
                          borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                          borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
                        }}
                      >
                        Total :
                      </td>
                      <td style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                    
                      </td>
                        <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                          {globalData?.totalmrp}
                      </td>
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                      {globalData?.totaldiscount}
                      </td>
                    
                    <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                        ₹{globalData?.totalsaleprice}
                      </td>
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                          
                      </td>    
                    
                      
                      
                      <td className="font-10" style={{ textAlign: "right", paddingRight: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                        ₹{globalData?.grandtotal}
                      </td>
                       </tr>
                     
                      <tr className="font-11">
                        <td
                          colSpan="5"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "left",
                            padding: "6px",
                          }}
                        >
                          <span className="fw-bold">Rupees in words:</span>{" "}
                          {globalData?.amountinwords}
                        </td>
                        <td
                        className="font-11"
                          colSpan="3"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            padding: "6px",
                            fontWeight: "bold",
                          }}
                        >
                          TOTAL AMOUNT : <span className="ms-2 font-11"> ₹{globalData?.grandtotal}</span> 
                        </td>
                    
                      </tr>
                     

                    </tfoot>
                  
                  </table>
                   {optData?.isRemark && globalData?.remark ? (
                      <>
                      <div className="font-12 mt-2 fw-600 text-black mb-1">
                       Remark
                      </div>
                    
                      <div
                      className="font-12 mb-2 p-0"
                  style={{              
                whiteSpace: "pre-wrap",
               wordBreak: "break-word",
              }}
               >
              {capitalizeFirstLetter(globalData?.remark)}
               </div>
              </>
                ) : null}  
                   <div className="row mt-2 p-2">                                     
                     <div className="col-4 p-2 pt-0  border-dark font-11">
                       {storeSettings?.paymentSettings?.bankDetails && optData?.isBankDetails && (
                         <>
                          <strong>Bank Details:</strong>
                           <div className="d-flex font-11">
                               <span style={{ width: "80px" }} >
                                Name:
                                </span>
                                 { storeSettings?.paymentSettings?.bankDetails?.beneficiaryName}
                          </div>
                           <div className="d-flex font-11">
                             <span style={{ width: "80px" }}>
                              Account #:
                             </span>
                             {storeSettings?.paymentSettings?.bankDetails?.accountNo}
                            </div>
                           <div className="d-flex font-11">
                           <span  style={{ width: "80px" }} >
                             IFSC:
                           </span>
                           {storeSettings?.paymentSettings?.bankDetails?.ifsc}
                            </div>
                          <div className="d-flex font-11">
                          <span style={{ width: "80px" }} >
                           UPI ID:
                           </span>
                           {storeSettings?.paymentSettings?.upiId}
                           </div>{" "}
                        </>
                       )}
                        </div>
                   {qrCodeDataUrl &&  optData?.isBankDetails && (
                       <div className="col-3 d-flex align-items-center justify-content-end">
                         <img
                           src={qrCodeDataUrl}
                          alt="QR"
                         style={{width: "100px",height: "100px",}}
                         />
                      </div>
                    )}                                           
                                                          
                 <div className="col-5  ms-auto">
                    <div className="text-end p-0 fw-bold font-12 mt-2 ">
                    {globalData?.salefrom?.title}
                    </div>
                      <div>
                    {storeSettings?.invoiceSettings
                   ?.signature ? (
                       <div className="text-end p-0 fw-bold pb-1">
                   <img
                     src={
                      uRLs.IMAGE_URL +storeSettings?.invoiceSettings?.signature}
                      width={100}
                  />
                   </div>
                ) : (
                  <div className="p-0 pt-4">
               <hr
                className="m-1 ms-auto "
            style={{
                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                 maxWidth: "120px",
              }}
               />
             </div>
                   )}
                     <div className="text-end p-0 font-12">
                  Authorized Signatory
                    </div>
                       </div>
                      </div>                                                      
                  </div>
                          <div className="d-flex mt-2 ">                       
                          <div className="font-10  fw-600"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        <strong>Terms & Conditions</strong>
                                   
                                      <div className="terms-box font-10">{storeSettings?.invoiceSettings?.termsAndConditions}</div>
                           </div>
                           

                          </div>
                  {storeSettings?.negobillBranding && (
                    <>
                      <div className="mt-5 font-12 d-flex justify-content-end ">
                        <span>
                          Powered By{" "}
                          <span className="fw-bold">NegoBill.com</span>
                        </span>
                      </div>
                    </>
                  )} 
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </>
    </>;
};

export default ClassicInvoice;